import React, { useEffect, useState } from "react";
import { ListGroup, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SplitPane from "react-split-pane";
import FieldDerivation from "./FieldDerivation";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import UseToggle from "../../../../Hooks/UseToggle";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FieldDerivationSchemaLists = ({ onMouseDown, tableRef }) => {
  const [schemaList, setSchemaList] = useState([]);
  const [eventFormList, setEventFormList] = useState([]);
  const { toggle, setToggle } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [schemaId, setSchemaId] = useState("");
  const [formFieldData, setFormFieldData] = useState("");
  const [eventLoader, setEventLoader] = useState(false);
  let { studyId } = useParams();

  const getEventFormSchema = async () => {
    setLoading(true);
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setSchemaList(data?.data || []);
    setLoading(false);
  };

  const getStudySchemaFormFieldList = async () => {
    setEventLoader(true);
    let data = await studyEventFormSchemaServices.getStudySchemaFormFieldList(
      studyId,
      schemaId
    );
    setEventFormList(data?.data || []);
    setEventLoader(false);
  };

  const handleDerivation = (data) => {
    setToggle();
    setFormFieldData(data);
  };

  useEffect(() => {
    if (schemaId) {
      getStudySchemaFormFieldList();
    }
  }, [schemaId]);

  useEffect(() => {
    getEventFormSchema();
  }, []);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"20%"}
        style={{ height: "calc(100vh - 145px)" }}
        className="position-relative"
      >
        {loading ? (
          <PageLoader />
        ) : schemaList?.length === 0 ? (
          <NoDataFoundTable MSG={"Field derivation schema not found!"} />
        ) : (
          <div className="p-2">
            <ListGroup>
              {schemaList?.map((schema, index) => (
                <ListGroup.Item
                  action
                  title={schema?.schemaName}
                  onClick={() => {
                    setSchemaId(schema?.schemaId);
                  }}
                  key={index}
                  style={{ padding: "7px 0px 7px 10px" }}
                  className={`hstack ${
                    schemaId === schema?.schemaId ? "selectedMenu" : "bg-white"
                  }`}
                >
                  <span>{schema?.schemaName}</span>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </div>
        )}
        {eventLoader ? (
          <PageLoader />
        ) : eventFormList?.length > 0 ? (
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  className="text-center"
                  style={{ width: 45 }}
                >
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>
                  Event Id (TimepointId)
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Form Name</th>
                <th onMouseDown={(e) => onMouseDown(e, 3)}>Field Name</th>
                <th onMouseDown={(e) => onMouseDown(e, 4)}>Derivation</th>
              </tr>
            </thead>
            <tbody>
              {eventFormList?.map((item, index) => (
                <tr
                  className="CP"
                  key={index}
                  onClick={() => handleDerivation(item)}
                >
                  <td className="text-center">{index + 1}</td>
                  <td>
                    {item?.eventName}{" "}
                    {item?.timePointUniqueId && `(${item?.timePointId})`}
                  </td>
                  <td>{item?.formLabel}</td>
                  <td>
                    {item?.fieldLabel} {`(v${item.formVersion})`}
                  </td>
                  <td>{`${item?.fieldDerivation?.eventName}${
                    item?.fieldDerivation?.timePointId || ""
                  } > ${item?.fieldDerivation?.formLabel} (v${
                    item?.fieldDerivation?.formVersion
                  }) > ${item?.fieldDerivation?.fieldLabel}`}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="hstack justify-content-center h-100">
            Click to view Event Form Field!
          </div>
        )}
      </SplitPane>
      <FieldDerivation
        Show={!toggle}
        Hide={setToggle}
        Title={"Assign Field"}
        getStudySchemaFormFieldList={getStudySchemaFormFieldList}
        schemaId={schemaId}
        formFieldData={formFieldData}
        studyId={studyId}
      />
    </>
  );
};

export default FieldDerivationSchemaLists;
